/* Detects visitors arriving from a PAID ad click (Meta/Facebook/Instagram,
 * Google, TikTok, etc.) so we can keep landing pages compliant with ad-network
 * "non-functional / low-quality landing page" policies — i.e. no disruptive
 * auto-launching interstitials or unexpected off-site redirects for ad clicks.
 *
 * Ad click IDs (fbclid, gclid, ...) and paid utm_source/medium values only
 * appear on the FIRST URL of the session, so once detected we persist a flag
 * in sessionStorage — it then holds for every client-side navigation until the
 * tab is closed. Organic visitors are unaffected. */

const FLAG_KEY = "ofin:paid_ad_session";

// Click-ID params set by ad networks on the destination URL.
const CLICK_ID_PARAMS = ["fbclid", "gclid", "msclkid", "ttclid", "twclid", "gbraid", "wbraid"];

// utm_source values that indicate paid social/search traffic.
const PAID_SOURCES = ["facebook", "instagram", "meta", "fb", "ig", "fbads", "igads", "meta-ads"];

// utm_medium values that indicate paid traffic.
const PAID_MEDIUMS = ["paid", "cpc", "ppc", "paidsocial", "paid-social", "paid_social", "cpm", "ads", "display"];

export function isPaidAdTraffic() {
  if (typeof window === "undefined") return false;

  try {
    if (sessionStorage.getItem(FLAG_KEY) === "1") return true;
  } catch { /* sessionStorage unavailable — fall through to URL check */ }

  let matched = false;
  try {
    const p = new URLSearchParams(window.location.search);
    const source = (p.get("utm_source") || "").toLowerCase();
    const medium = (p.get("utm_medium") || "").toLowerCase();

    matched =
      CLICK_ID_PARAMS.some((k) => p.has(k)) ||
      PAID_SOURCES.includes(source) ||
      PAID_MEDIUMS.includes(medium);
  } catch { /* no-op */ }

  if (matched) {
    try { sessionStorage.setItem(FLAG_KEY, "1"); } catch { /* ignore */ }
  }
  return matched;
}
